export const SERVER_URL = process.env.REACT_APP_WEBSOCKET_PREFIX || '/api/websocket'

export default SERVER_URL
